import { Component, ViewEncapsulation, OnInit, Input, ElementRef, HostBinding, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { IconService } from './icon.service';
import { CHECK_MOD_CLASSNAME } from './helpers';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UiIconComponent implements OnInit, OnChanges {
  _baseClass = 'icon';
  _classList: string[] = [this._baseClass];
  _checkClassMod: Function;

  @Input() size: string;
  @Input() color: string;
  @Input() glyph: string;

  @Input('class')
  set classListInput(classList: string) {
    if (classList && classList.length) {
      classList.split(' ').forEach((className) => this._classList.push(className.trim()));
    }
  }

  @HostBinding('class')
  get classList(): string {
    return this._classList.join(' ');
  }

  constructor(
    private el: ElementRef,
    private iconService: IconService
  ) {
    this._checkClassMod = CHECK_MOD_CLASSNAME.bind(this);
  }

  ngOnInit() {
    this.setMods();
    this.el.nativeElement.innerHTML = this.iconService.get(this.glyph);
  }

  ngOnChanges() {
    this.setMods();
  }

  setMods() {
    if (this.size) {
      this._checkClassMod('size');
    }
    if (this.color) {
      this._checkClassMod('color');
    }
  }
}
